import {
  LIST_MCU_PROJECT_PATIENT_REQUEST,
  LIST_MCU_PROJECT_PATIENT_SUCCESS,
  LIST_MCU_PROJECT_PATIENT_FAIL,
  LIST_MCU_PROJECT_PATIENT_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_PATIENT_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_PATIENT_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_PATIENT_REQUEST,
  CREATE_MCU_PROJECT_PATIENT_SUCCESS,
  CREATE_MCU_PROJECT_PATIENT_FAIL,
  DETAIL_MCU_PROJECT_PATIENT_REQUEST,
  DETAIL_MCU_PROJECT_PATIENT_SUCCESS,
  DETAIL_MCU_PROJECT_PATIENT_FAIL,
  UPDATE_MCU_PROJECT_PATIENT_REQUEST,
  UPDATE_MCU_PROJECT_PATIENT_SUCCESS,
  UPDATE_MCU_PROJECT_PATIENT_FAIL,
  DELETE_MCU_PROJECT_PATIENT_REQUEST,
  DELETE_MCU_PROJECT_PATIENT_SUCCESS,
  DELETE_MCU_PROJECT_PATIENT_FAIL,
  RESET_MCU_PROJECT_PATIENT_BATCH
} from '../../constants/mcu-project-patient'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  generalProjectPatients: [],
  mcuProjectPatient: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectPatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_PATIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        generalProjectPatients: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        generalProjectPatients: action?.dummy
      }
    case LIST_MCU_PROJECT_PATIENT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_PATIENT_SUMMARY_SUCCESS:
      return { ...state, loading: false, generalProjectPatients: action.payload }
    case LIST_MCU_PROJECT_PATIENT_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_MCU_PROJECT_PATIENT_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_MCU_PROJECT_PATIENT_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_MCU_PROJECT_PATIENT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_MCU_PROJECT_PATIENT_REQUEST:
      return { ...state, loadingCreate: true, mcuProjectPatient: {}, loadingDetail: true }
    case DETAIL_MCU_PROJECT_PATIENT_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        loadingDetail: false,
        mcuProjectPatient: action.payload
      }
    case DETAIL_MCU_PROJECT_PATIENT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload, loadingDetail: false}
    case UPDATE_MCU_PROJECT_PATIENT_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_MCU_PROJECT_PATIENT_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_MCU_PROJECT_PATIENT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_MCU_PROJECT_PATIENT_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_MCU_PROJECT_PATIENT_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_MCU_PROJECT_PATIENT_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_MCU_PROJECT_PATIENT_BATCH:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default mcuProjectPatientReducer
